



















































































































































import { Component, Prop, Inject } from 'vue-property-decorator';
import { SwExtendedVue } from '../sw-extended-vue';
import { SwIcon } from '../sw-icon';
import { SwTransitionExpand } from '../sw-transition';
import { CSSStyleOptions } from '../common-types';
import SwTreeList from './sw-tree-list.vue';
import SwTreeListPlusTrigger from './sw-tree-list-plus-trigger.vue';
import { ProvidedListParam, InternalItemHieDescriptor } from './types';
import { utilService } from '../util-service';

const cssPrefix = 'sw-tree-list-item';

/**
 * Events:
 * @event hover-item `(isHover: boolean)`
 */
@Component({
  name: 'SwTreeListItem', // as we will use this name to determine this component
  components: {
    SwIcon,
    SwTransitionExpand,
    SwTreeListPlusTrigger,
  },
})
export default class SwTreeListItem extends SwExtendedVue {
  @Prop({ type: String, required: true })
  itemId: string;

  /** will be updated by `sw-tree-list` from the top */
  public hieDescriptor: InternalItemHieDescriptor = {
    level: 1,
    ancestorsNextSiblingFlags: [],
    isLastSibling: false,
  };
  private cssPrefix = cssPrefix;

  @Inject()
  readonly listParam: ProvidedListParam;

  get triggerLeftPadding(): number {
    return Math.min(this.listParam.initialPadding[0], 6);
  }

  get padLeftPadding(): number {
    return this.triggerLeftPadding + 6;
  }

  get padStyle(): CSSStyleOptions {
    return {
      paddingLeft: `${this.padLeftPadding}px`,
      width: `${Math.max(this.listParam.indent, 14)}px`,
    };
  }

  get isSelected() {
    return this.listParam.selectedItems.includes(this.itemId);
  }

  get isPlusMinusTrigger() {
    return this.listParam.triggerStyle === 'plus-minus';
  }

  private isExpanded(): boolean {
    if (!this.isParent()) { return false; }
    return this.listParam.expandedItems.includes(this.itemId);
  }

  private isParent(): boolean {
    const slot = utilService.getVueScopedSlot(this.$scopedSlots);
    return slot.filter((node) => {
      return !!node.componentOptions && node.componentOptions.Ctor === SwTreeListItem;
    }).length > 0;
  }

  private mainContStyle(): CSSStyleOptions {
    let pLeft = this.listParam.initialPadding[0]; // + ((this.hieDescriptor.level - 1) * 24);
    if (!this.listParam.flat) { pLeft -= this.triggerLeftPadding; }
    return {
      paddingLeft: `${pLeft}px`,
    };
  }

  @Inject()
  readonly claimItemSelecting: SwTreeList['claimItemSelecting'];

  @Inject()
  readonly claimParentExpanding: SwTreeList['claimParentExpanding'];

  private onClickItem() {
    this.claimItemSelecting(this.itemId, !this.isSelected);
  }

  private onEnterItem() {
    this.$emit('hover-item', true);
  }

  private onLeaveItem() {
    this.$emit('hover-item', false);
  }

  private onClickTrigger(event: MouseEvent) {
    if (this.isParent()) { event.stopPropagation(); }
    this.claimParentExpanding(this.itemId, !this.isExpanded());
  }
}
